import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { v4 as uuid } from 'uuid';

import { SOURCE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import type { FetchRssSource as Source } from '@/types';

type ResponseType = {
  results?: Source[];
};

export const QUERY_KEY_ALL = 'all-websites';

export const useFetchAllWebsites = () => {
  const placeholderData: Source[] = React.useMemo(
    () =>
      Array.from({ length: 5 }).map(() => ({
        isLoading: true,
        source_id: uuid(),
        priority: 'LOW',
        label: '',
        link_to_crawl: '',
        thumbnail_location: '',
      })),
    []
  );

  const { isLoading, isError, data } = useQuery(
    [QUERY_KEY_ALL],
    ({ signal }) =>
      axiosInstance.get<ResponseType>(SOURCE_API_ROUTES.rss(), { signal }),
    {
      staleTime: 60 * 1000,
      select: (data) => {
        return data.data['results'];
      },
    }
  );

  return { isLoading, isError, sources: data, placeholderData };
};

export const useRefetchAllWebsites = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries([QUERY_KEY_ALL]);
  };
};
